{
  "general": {
    "title": "Vertaa vaihtoehtoja",
    "intro": "Nopea katsaus yhteisön, tilauksen ja kertaluonteisen oston väliseen eroon.",
    "tableheader": "Tilaus",
    "note1": "* Ryhmäostovaihtoehdot ja volyymialennus saatavilla.",
    "note2": "** Tuetut kielet Dansk, Deutsch, English, Español, Suomi, Français, Italiano, Norsk, Polski, Português (Brasil), Русский, Svenska",
    "note3": "*** Vaatii ilmaisen myboardmaker.com-yhteisötilin, ja se on tarkoitettu vain toimintojen tallennukseen."
  },
  "columnHeadings": {
    "community": "YHTEISÖ",
    "onetime": "KERTALUONTEINEN OSTOS*",
    "personal": "HENKILÖKOHTAISET",
    "professional": "AMMATTIMAINEN",
    "organization": "ORGANISAATIO*"
  },
  "mobileHeadings": {
    "community": "Yhteisö",
    "onetime": "Kertaluontoinen Ostos*",
    "personal": "Henk.koht.",
    "professional": "Ammatillinen",
    "organization": "Organisaatio*"
  },
  "rowHeadings": {
    "editor": "Boardmaker 7 Editor",
    "activations": "Aktivoinnit",
    "languages": "Kielet**",
    "licensing": "Lisensointi",
    "pcsSymbols": "PCS-symbolit",
    "templates": "Mallit",
    "studentCenter": "Boardmaker 7 Student Center",
    "playActivitiesInstructor": "Leikkitoiminnot ohjaajana",
    "playActivitiesStudent": "Leikkitoiminnot opiskelijana",
    "myBoardmaker": "myBoardmaker",
    "instructorManagement": "Ohjaajien hallinta",
    "studentManagement": "Opiskelijahallinto",
    "assignStudentActivities": "Määritä opiskelijan aktiviteetit",
    "cloudStorage": "Pilvitallennus",
    "createAndJoin": "Luo ryhmiä ja liity niihin",
    "accessCommunity": "Pääsy yli 120k yhteisön toimintaan",
    "shareActivity": "Jaa toimintaa yhteisössä",
    "curriculum": "Opetussuunnitelma ja sisältö",
    "activitiesToGo": "Boardmaker Activities to Go",
    "instructionalSolutions": "Opetukselliset ratkaisut",
    "premiumActivities": "Premium-toiminta",
    "coreFirstLearning": "Core First Learning"
  },
  "rowValues": {
    "byDevice": "2 Laitteet",
    "unlimited": "Rajoittamaton",
    "byKey": "Lisenssiavain",
    "symbols": "80000+",
    "templates": "600+",
    "languages": "12",
    "login": "Kirjautuminen",
    "yes": "Kyllä",
    "yesNote": "Kyllä***",
    "no": "Ei"
  }
}
